<template>
  <div class="cart">

    <v-dialog

        v-model="open_cart_select_dialog"
        width="600"

    >
      <v-card class="pa-4" style="">


        <!--<v-card-text>-->
        <v-btn v-for="(cart, index) in $store.state.carts.data"
               v-if="cart"
               :class="{primary:cart.id===$store.state.carts.current.id}"
               class="mt-2"
               style="width: 100%;position: relative;margin:auto"
               @click="ChooseCart(cart,index)"
        >
          <span v-if="cart.customer">
            {{ cart.customer.nickname }}
          </span>
          <span v-if="cart.items">
          [{{ cart.items.length }} รายการ]
          </span>
          [{{ number_format(cart.total_net, 2, 2) }} บาท]
        </v-btn>
        <br/>

        <!--</v-card-text>-->

      </v-card>
    </v-dialog>

    <v-dialog

        v-model="open_address_select_dialog"
        width="400"

    >

      <v-card v-if="$store.state.carts.current.customer" class="pa-4"
              style=""
      >


        <!--<v-card-text>-->
        <v-btn v-for="(address, index) in $store.state.carts.current.customer.shipping_addresses"

               :class="{primary:address.id===$store.state.carts.current.shipping_address_id}"
               class="mt-2 pa-2"
               style="width: 100%;position: relative;margin:auto;height: auto"
               @click="ChooseAddress(address,index)"
        >
          {{ address.name }}<br/>
          {{ address.address }}<br/>
          {{ address.district && address.district.name }}
          {{ address.city && address.city.name }}
          {{ address.province && address.province.name }}
        </v-btn>

        <v-btn
            class="mt-2 pa-2"
            style="width: 100%;position: relative;margin:auto"
            @click="addAddress"
        >
          เพิ่ม
        </v-btn>
        <br/>

        <!--</v-card-text>-->

      </v-card>
    </v-dialog>

    <!--<CalculatorDialog :open="true"></CalculatorDialog>-->
    <OrderConfirmDialog></OrderConfirmDialog>
    <OrderConfirmDialogPoint></OrderConfirmDialogPoint>
    <div v-if="carts_tab.isLoad "
         style="margin: auto;text-align: center;margin-top: 120px;">
      <h1>... Loading ...</h1>
    </div>
    <v-content v-else-if="isChooseCustomer" class="choose-customer">


      <v-card class="mt-10" style="margin: auto;text-align: center" width="500">
        <h4>กรุณากดเลือกลูกค้า</h4>
        <v-img
            aspect-ratio="1.34"
            src="/images/tutorials/cart_choose_customer.gif"
        ></v-img>
      </v-card>

    </v-content>
    <v-content v-else>
      <!-- Point Order Components -->
      <template v-if="$store.state.carts.current && $store.state.carts.current.pay_by === 'point'">
        <HeaderPoint v-if="$store.state.carts.current"
                :onClickSelectAddress="onClickSelectAddress"
                :onClickSelectCart="onClickSelectCart"
                :order="$store.state.carts.current"
        ></HeaderPoint>
        <BodyPoint v-if="$store.state.carts.current"
              :dummyOrder="$store.state.carts.current" :height="bodyHeight"></BodyPoint>
        <FooterPoint v-if="$store.state.carts.current"
                :onClickSelectAddress="onClickSelectAddress"
                :onSubmitted="onSubmitted"
                :order="$store.state.carts.current"></FooterPoint>
      </template>

      <!-- Money Order Components (default) -->
      <template v-else>
        <Header v-if="$store.state.carts.current"
                :onClickSelectAddress="onClickSelectAddress"
                :onClickSelectCart="onClickSelectCart"
                :order="$store.state.carts.current"
        ></Header>
        <Body v-if="$store.state.carts.current"
              :dummyOrder="$store.state.carts.current" :height="bodyHeight"></Body>
        <Footer v-if="$store.state.carts.current"
                :onClickSelectAddress="onClickSelectAddress"
                :onSubmitted="onSubmitted"
                :order="$store.state.carts.current"></Footer>
      </template>
    </v-content>

  </div>
</template>
<style scoped>
.choose-customer {
  width: 100%;
  padding-top: 30px;
  font-size: 2em;
}

</style>
<script lang="ts">
import Body from '@/components/Cart/Body.vue'
import Footer from '@/components/Cart/Footer.vue'
import Header from '@/components/Cart/Header.vue'
import BodyPoint from '@/components/Cart/BodyPoint.vue'
import FooterPoint from '@/components/Cart/FooterPoint.vue'
import HeaderPoint from '@/components/Cart/HeaderPoint.vue'
import {CustomerAddress} from '@/models/CustomerAddress'
import {Order} from '@/models/Order'
import {Promotion} from '@/models/Promotion'
import {DataArray} from '@/models/Response'
import {gVariable} from '@/services/globalData'
import Helper from '@/services/Helper'
import {Component, Vue} from 'vue-property-decorator'
import CalculatorDialog from '../dialogs/CalculatorDialog.vue'
import OrderConfirmDialog from '../dialogs/OrderConfirmDialog.vue'
import OrderConfirmDialogPoint from '../dialogs/OrderConfirmDialogPoint.vue'
import router from '../router'

/*


 */

@Component({
  components: {
    CalculatorDialog,
    OrderConfirmDialog,
    OrderConfirmDialogPoint,
    Header,
    Body,
    Footer,
    HeaderPoint,
    BodyPoint,
    FooterPoint,
  },
})
export default class ViewCart extends Vue {
  carts_tab = gVariable.tabs.carts
  open_cart_select_dialog = false
  open_address_select_dialog = false
  isChooseCustomer = true
  store = this.$store.state.carts
  promotionLoading = false
  private windowInnerHeight: number = window.innerHeight
  private headerHeight: number = 150
  private footerHeight: number = 150

  number_format = this.$helper.number_format

  get bodyHeight() {
    return this.windowInnerHeight - 64 - this.headerHeight - this.footerHeight
  }

  mounted() {
    window.addEventListener('resize', this.handleResize)
    this.getItem()


  }

  recalPromotion() {
    //this.$store.state.

  }

  async getItem(): Promise<void> {
    gVariable.tabs.carts.isLoad = true
    await this.$store.dispatch('load_dynamicPromotions')
    await this.$store.dispatch('load_carts')

    if (this.store.response &&
        this.store.response.data) {
      this.isChooseCustomer = this.store.response.data.length == 0
    }


  }

  onClickSelectAddress() {
    // debugger
    this.open_address_select_dialog = true
  }

  onClickSelectCart() {
    // debugger
    this.open_cart_select_dialog = true
  }

  onSubmitted(order: Order) {
    if (this.store.response &&
        this.store.response.data) {
      // debugger
      this.isChooseCustomer = this.store.response.data.length == 0
    }
    // this.$root.$emit('onSuccess', {'message':'[yom7dgiup[ihvp'})


    this.$root.$emit('openOrder', {
      order: order, skip_load: true, onApply: () => {
        // debugger
        // this.getItem()
        router.push('/order')
      },
    })

    // router.push('/order/status/' + OrderConst.STATUS_SUBMITTED_PENDING_CONFIRM + '/id/' + order.id)


  }

  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  }

  handleResize(): void {
    // alert(window.innerHeight);
    this.windowInnerHeight = window.innerHeight
  }

  async ChooseCart(cart, index) {
    this.$store.commit('carts_index', index)
    this.open_cart_select_dialog = false


  }

  async ChooseAddress(address, index) {

    this.$store.state.carts.current.shipping_address_id = address.id
    this.open_address_select_dialog = false


  }

  async saveAddress(cusAddress: CustomerAddress) {

    const isNew = cusAddress?.id === null

    cusAddress = Object.setPrototypeOf(cusAddress, CustomerAddress.prototype)

    if (cusAddress) {
      try {
        let object = await cusAddress.save<CustomerAddress>()
        this.$root.$emit('onSuccess', {message: 'บันทึกสำเร็จ'})

        const addresses = this.$store.state.carts.current.customer.shipping_addresses
        if (isNew) {
          addresses.push(object)
        } else {
          for (let i in addresses) {
            if (addresses[i].id == object.id) {
              addresses[i] = object
            }
          }
        }
        this.$store.state.carts.current.shipping_address_id = addresses.id
      }catch (e){
        this.$root.$emit('onError', {error: e})
      }
    }
  }

  addAddress() {
    const customer = this.$store.state.carts.current.customer
    let address = new CustomerAddress()
    address.customer_id = customer.id
    address.name = customer.name
    address.address = customer.address
    address.district = customer.district_obj
    address.district_id = customer.district_id
    address.city = customer.city_obj
    address.city_id = customer.city_id
    address.province = customer.province_obj
    address.province_id = customer.province_id
    address.zip_code = customer.zip_code
    address.contact_tel = customer.erp_tel
    address.cache_lat = customer.cache_lat
    address.cache_lng = customer.cache_lng
    this.$root.$emit('openAddress', {
      address: address, onApply: this.saveAddress,
    })
  }


};

</script>
